import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";
import { useOrgController } from "../../auth/org-provider";

interface Options {
    onSuccess?: () => void;
}

export function useImportSlackUsersMutation(options: Options) {
    const orgController = useOrgController();
    return useMutation({
        mutationFn: async () => {
            await apiClient.importSlackUsers({
                body: undefined,
            });
            await orgController.refetch();
        },
        onSuccess: options?.onSuccess,
    });
}
